module.exports = __webpack_public_path__ + "img/logo-w.da0603c4.png";